// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AuthContextUserFragment = {
  __typename?: 'User';
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  pictureLink?: string | null;
  createdAt: number;
  isOps?: boolean | null;
  phoneNumber?: {
    __typename?: 'PhoneNumber';
    callingCountryCode: string;
  } | null;
  applicant?: { __typename?: 'Applicant'; id: string } | null;
  impersonator?: { __typename?: 'User'; id: string } | null;
  coach?: { __typename?: 'Coach'; id: string; slug: string } | null;
  userSecrets?: {
    __typename?: 'UserSecrets';
    id: string;
    firstContact?: {
      __typename?: 'FirstContact';
      gclid?: string | null;
      source?: string | null;
      medium?: string | null;
      campaign?: string | null;
      referrer?: string | null;
    } | null;
  } | null;
};

export type AuthContextQueryVariables = Types.Exact<{ [key: string]: never }>;

export type AuthContextQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
    createdAt: number;
    isOps?: boolean | null;
    phoneNumber?: {
      __typename?: 'PhoneNumber';
      callingCountryCode: string;
    } | null;
    applicant?: { __typename?: 'Applicant'; id: string } | null;
    impersonator?: { __typename?: 'User'; id: string } | null;
    coach?: { __typename?: 'Coach'; id: string; slug: string } | null;
    userSecrets?: {
      __typename?: 'UserSecrets';
      id: string;
      firstContact?: {
        __typename?: 'FirstContact';
        gclid?: string | null;
        source?: string | null;
        medium?: string | null;
        campaign?: string | null;
        referrer?: string | null;
      } | null;
    } | null;
  } | null;
};

export const AuthContextUserFragmentDoc = gql`
  fragment AuthContext_User on User {
    id
    email
    firstName
    lastName
    pictureLink
    createdAt
    phoneNumber {
      callingCountryCode
    }
    applicant {
      id
    }
    impersonator {
      id
    }
    isOps
    coach {
      id
      slug
    }
    userSecrets {
      id
      firstContact {
        gclid
        source
        medium
        campaign
        referrer
      }
    }
  }
`;
export const AuthContextDocument = gql`
  query AuthContext {
    user {
      id
      ...AuthContext_User
    }
  }
  ${AuthContextUserFragmentDoc}
`;

/**
 * __useAuthContextQuery__
 *
 * To run a query within a React component, call `useAuthContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthContextQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AuthContextQuery,
    AuthContextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AuthContextQuery, AuthContextQueryVariables>(
    AuthContextDocument,
    options,
  );
}
export function useAuthContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuthContextQuery,
    AuthContextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AuthContextQuery, AuthContextQueryVariables>(
    AuthContextDocument,
    options,
  );
}
export function useAuthContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AuthContextQuery,
        AuthContextQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AuthContextQuery, AuthContextQueryVariables>(
    AuthContextDocument,
    options,
  );
}
export type AuthContextQueryHookResult = ReturnType<typeof useAuthContextQuery>;
export type AuthContextLazyQueryHookResult = ReturnType<
  typeof useAuthContextLazyQuery
>;
export type AuthContextSuspenseQueryHookResult = ReturnType<
  typeof useAuthContextSuspenseQuery
>;
export type AuthContextQueryResult = Apollo.QueryResult<
  AuthContextQuery,
  AuthContextQueryVariables
>;
